import type GestureHelper from './GestureHelper';

/**
 * @deprecated
 */
class GestureList {
  constructor(private items: GestureHelper[]) {
  }

  start() {
    this.items.forEach((item) => item.start());
    return this;
  }

  stop() {
    this.items.forEach((item) => item.stop());
    return this;
  }

  destroy() {
    this.items.forEach((item) => item.destroy());
    return this;
  }
}

export default GestureList;
